import Registry from "../registry";
import React from "react";
import text from "./text";

const textArea = {
  name: "Textarea",
  group: "Basic",
  schema: part => ({
    ...text,
    component: locals => (
      <textarea
        value={locals.value || ""}
        className="form-control"
        onChange={e => locals.onChange(e.target.value)}
      />
    ),
    render: ({ value }) =>
      value && value.length > 100 ? value.substring(0, 100) + "..." : value
  })
};

Registry.register("textarea", textArea);

export default textArea;



// WEBPACK FOOTER //
// ./app/parts/textarea.js